import { useStaticRendering } from "mobx-react"

import ApplicationStore from "./ApplicationStore"
import BadgeStore from "./BadgeStore"
import CompanyStore from "./CompanyStore"
import CourseStore from "./CourseStore"
import EventStore from "./EventStore"
import FavoriteStore from "./FavoriteStore"
import InputProfileFlowStore from "./InputProfileFlowStore"
import LongInternshipStore from "./LongInternshipStore"
import MagazineStore from "./MagazineStore"
import MasterDataStore from "./MasterDataStore"
import NewGradJobStore from "./NewGradJobStore"
import ProfileStore from "./ProfileStore"
import ShortInternshipStore from "./ShortInternshipStore"
import UiStore from "./UiStore"
import UserStore from "./UserStore"

const isServer = typeof window === undefined
useStaticRendering(isServer)

export default class RootStore {
  applicationStore: ApplicationStore = new ApplicationStore()
  companyStore: CompanyStore = new CompanyStore()
  eventStore: EventStore = new EventStore()
  favoriteStore: FavoriteStore = new FavoriteStore()
  longInternshipStore: LongInternshipStore = new LongInternshipStore()
  magazineStore: MagazineStore = new MagazineStore()
  newGradJobStore: NewGradJobStore = new NewGradJobStore()
  shortInternshipStore: ShortInternshipStore = new ShortInternshipStore()
  userStore: UserStore = new UserStore()
  profileStore: ProfileStore = new ProfileStore()
  courseStore: CourseStore = new CourseStore()
  uiStore: UiStore = new UiStore()
  inputProfileFlowStore: InputProfileFlowStore = new InputProfileFlowStore()
  masterDataStore: MasterDataStore = new MasterDataStore()
  badgeStore: BadgeStore = new BadgeStore()
  // サーバーサイドで取得してStoreに格納したデータをフロントエンド用のStoreに注入する
  static initializeFromProps(initialStoreData: RootStore) {
    const rootStore = new RootStore()
    rootStore.userStore.user = initialStoreData.userStore.user
    // rootStore.companyStore.companies = initialStoreData.companyStore.companies
    // rootStore.abStore.patternType = initialStoreData.abStore.patternType
    return rootStore
  }

  async initializeData() {
    // www.in-fra.jpのcookie情報で認証しているので、
    // この関数を呼び出している_app.tsx > getInitialProps()からサーバーサイドでは認証が通らない
    // await this.userStore.fetchLoginUser()
    // await this.companyStore.fetch()
    // await this.abStore.fetchPattern()
  }
}
